__turbopack_context__.v({
  "blocksBackgroundColor": "SchoolFeedDisplay-module-scss-module__q43QwG__blocksBackgroundColor",
  "blocksFontColor": "SchoolFeedDisplay-module-scss-module__q43QwG__blocksFontColor",
  "displayContainer": "SchoolFeedDisplay-module-scss-module__q43QwG__displayContainer",
  "eventList": "SchoolFeedDisplay-module-scss-module__q43QwG__eventList",
  "eventsWidget": "SchoolFeedDisplay-module-scss-module__q43QwG__eventsWidget",
  "feedContainer": "SchoolFeedDisplay-module-scss-module__q43QwG__feedContainer",
  "header": "SchoolFeedDisplay-module-scss-module__q43QwG__header",
  "horizontalScrollContainer": "SchoolFeedDisplay-module-scss-module__q43QwG__horizontalScrollContainer",
  "horizontalScrollContentContainer": "SchoolFeedDisplay-module-scss-module__q43QwG__horizontalScrollContentContainer",
  "link": "SchoolFeedDisplay-module-scss-module__q43QwG__link",
  "linkActive": "SchoolFeedDisplay-module-scss-module__q43QwG__linkActive",
  "loadingContainer": "SchoolFeedDisplay-module-scss-module__q43QwG__loadingContainer",
  "loginButtons": "SchoolFeedDisplay-module-scss-module__q43QwG__loginButtons",
  "newsFeedContainer": "SchoolFeedDisplay-module-scss-module__q43QwG__newsFeedContainer",
  "newsLoading": "SchoolFeedDisplay-module-scss-module__q43QwG__newsLoading",
  "newsLoadingWrapper": "SchoolFeedDisplay-module-scss-module__q43QwG__newsLoadingWrapper",
  "secondaryNavBackgroundColor": "SchoolFeedDisplay-module-scss-module__q43QwG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "SchoolFeedDisplay-module-scss-module__q43QwG__themeBackgroundColor",
  "themeFontColor": "SchoolFeedDisplay-module-scss-module__q43QwG__themeFontColor",
  "themeFontFamily": "SchoolFeedDisplay-module-scss-module__q43QwG__themeFontFamily",
  "upcomingNews": "SchoolFeedDisplay-module-scss-module__q43QwG__upcomingNews",
  "widget": "SchoolFeedDisplay-module-scss-module__q43QwG__widget",
});
